// removed by extract-text-webpack-plugin
module.exports = {"content":"header__content-1Sr64 blocks__content--MOaB","inline-block-element":"header__inline-block-element-3tBRb","logo":"header__logo-gr1fb","menu":"header__menu-1ESln","menuSmall":"header__menuSmall-2ADM7","link":"header__link-2Hmkp","isActive":"header__isActive-3RDen","phone":"header__phone-omfm4","phoneLink":"header__phoneLink-1SKLV","freeCall":"header__freeCall-IQ9bv","user":"header__user-G7LrQ","userMenu":"header__userMenu-BttS7","login":"header__login-cGmCC blocks__button-1iODk blocks__green-2w7kK","redirect":"header__redirect-4pPF0"};


//////////////////
// WEBPACK FOOTER
// ./components/layout/header/header.css
// module id = 839
// module chunks = 0